import CurrencyIcon from '../../../../../../../apps/frontend/src/components/idea-management/icons/customFields/Currency';
import DateIcon from '../../../../../../../apps/frontend/src/components/idea-management/icons/customFields/Date';
import Fibonacci from '../../../../../../../apps/frontend/src/components/idea-management/icons/customFields/Fibonacci';
import Formula from '../../../../../../../apps/frontend/src/components/idea-management/icons/customFields/Formula';
import MultiSelect from '../../../../../../../apps/frontend/src/components/idea-management/icons/customFields/MultiSelect';
import NumberIcon from '../../../../../../../apps/frontend/src/components/idea-management/icons/customFields/Number';
import Percent from '../../../../../../../apps/frontend/src/components/idea-management/icons/customFields/Percent';
import Rating from '../../../../../../../apps/frontend/src/components/idea-management/icons/customFields/Rating';
import SingleSelect from '../../../../../../../apps/frontend/src/components/idea-management/icons/customFields/SingleSelect';
import TextIcon from '../../../../../../../apps/frontend/src/components/idea-management/icons/customFields/Text';
import UserIcon from '../../../../../../../apps/frontend/src/components/idea-management/icons/customFields/User';

export const CustomFieldIcon = ({
  fieldType,
  isMulti,
}: {
  fieldType?: string;
  isMulti?: boolean;
  isSystem?: boolean;
}) => {
  switch (fieldType) {
    case 'NUMBER':
      return <NumberIcon />;
    case 'DATE':
    case 'DATE_RANGE':
      return <DateIcon />;
    case 'RATING':
      return <Rating />;
    case 'CURRENCY':
      return <CurrencyIcon />;
    case 'PERCENT':
      return <Percent />;
    case 'FIBONACCI':
      return <Fibonacci />;
    case 'LIST':
      if (isMulti) {
        return <MultiSelect />;
      } else {
        return <SingleSelect />;
      }
    case 'FORMULA':
      return <Formula />;
    case 'USER':
      return <UserIcon />;
    default:
      return <TextIcon />;
  }
};
